<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part" id="part-001"><span epub:type="pagebreak" id="page_3" title="3"><div class="part_debut"></div><h1 class="part_n" epub:type="title"><span>PART I</span></h1>
<h1 class="part_tit" epub:type="title"><span>Yalta</span></h1><h1 class="part_stit" epub:type="subtitle"><span>Friends</span></h1></span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1.vue?e0462368